import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const positionToStyleMap = {
  top: styles.top,
  right: styles.right,
  bottom: styles.bottom,
  left: styles.left
};
const widthToStyleMap = {
  thin: styles.thin,
  medium: styles.medium,
  thick: styles.thick,
  dense: styles.dense
};
const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Border(props) {
  const {
    className,
    active,
    errored,
    position = 'bottom',
    disabled,
    transparent,
    fullWidthActiveBorder,
    width = 'medium',
    inline,
    spacing = 'comfortable',
    extendToSpacing
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.border, active && styles.active, errored && styles.errored, positionToStyleMap[position] ?? styles.bottom, disabled && styles.disabled, transparent && styles.transparent, fullWidthActiveBorder && styles.fullWidthActiveBorder, widthToStyleMap[width], !inline && styles.absolutelyPositioned, spacingToStyleMap[spacing], extendToSpacing && styles.extendToSpacing, className)
  }, active && /*#__PURE__*/React.createElement("div", {
    className: styles.activeBorder
  }));
}

var Border$1 = genericMemo(Border);

export { Border$1 as default };
//# sourceMappingURL=index.js.map
